import { useState, useEffect } from "react";
import type { ReactNode } from "react";
import { MenuIcon, CloseIcon } from "../../../shared/cockpit/components/icons/Icon";
import "./CockpitLayout.scss";

//Das CockpitLayout umfasst die linke Cockpit-Seitenleiste und den gesamten rechten Rahmen
//mit dem schmalen weißen Streifen oben

interface CockpitLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

function CockpitLayout({ sidebar, children }: CockpitLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((previous) => !previous);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isSidebarOpen]);

  return (
    <div
      className={`cockpit-layout ${isSidebarOpen ? "cockpit-layout--sidebar-open" : ""}`}
    >
      <aside className="cockpit-layout__sidebar">
        <div className="cockpit-layout__sidebar-header">
          <button
            type="button"
            className="cockpit-layout__toggle cockpit-layout__toggle--close"
            onClick={toggleSidebar}
            aria-label="Cockpit-Navigation schließen"
          >
            <CloseIcon />
          </button>
        </div>
        {sidebar}
      </aside>

      {isSidebarOpen && (
        <div className="cockpit-layout__overlay" onClick={toggleSidebar} />
      )}

      <div className="cockpit-layout__main">
        <header className="cockpit-layout__header">
          <button
            type="button"
            className="cockpit-layout__toggle"
            onClick={toggleSidebar}
            aria-label="Cockpit-Navigation öffnen"
          >
            <MenuIcon />
          </button>
        </header>
        <div className="cockpit-layout__content">
          <div className="cockpit-layout__content-main">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CockpitLayout;
